import React from "react";
import dynamic from "next/dynamic";
import FindNodeInput from "../whole-graph/filters/elements/FindNodeInput";


const InteractiveGraph = dynamic(() => import("../InteractiveGraph"), {
    ssr: false,
  });


export default function ZeroBaseFeeGraph() {
    return (
        <div>
            <div className="row">
                <div className="" style={{height: "70vh"}}>
                    <InteractiveGraph pruneDuplicatedEdges={false} renderer="zeroBaseFee" height="70vh">
                    <div className="absolute top-0 z-20 pl-1 pt-1" >
                                <div className="w-full" style={{ width: '300px' }}>
                                    <FindNodeInput variant="plain" />
                                </div>
                            </div>
                    </InteractiveGraph>
                </div>
            </div>
        </div>
    );
}

